// message.ts
import type { MessageInstance } from 'antd/es/message/interface';

let messageApi: MessageInstance;

export const setMessageApi = (api: MessageInstance) => {
  messageApi = api;
};

export const getMessageApi = () => messageApi;
